import { breakpoints } from "@brightagency/headstart-common";
import styled from "styled-components";

export const SortButtonWrapper = styled.div`
    margin-right: 0;
    width: 100%;
    text-align: left;

    ${breakpoints.large} {
        margin-right: 24px;
    }

    .carousel-wrapper{
        background-color: transparent;
        padding: 0;

        .carousel-item{
            ${breakpoints.small} {
                width: auto !important;
            }
        }
    }
`;
